export let rowPositions = {
  top: [-2.6, 2.006, -1.95],
  middle: [-2.6, 1.42, -1.95],
  bottom: [-2.6, 0.83, -1.95],
};

export const books = {
  topRow: [
    {
      name: "react",
      color: "#11a7ed",
      position: [0, 0, 0.012],
      scale: [1, 1.3, 1],
      textPosition: [0, -0.015, 0],
    },
    {
      name: "angular",
      color: "#c22749",
      position: [0, 0, -0.095],
      scale: [1, 1, 1],
      textPosition: [0, 0.065, 0],
    },
    {
      name: "vue",
      color: "#15ad54",
      position: [0, 0, -0.2],
      scale: [1, 1.09, 1],
      textPosition: [0, -0.025, 0],
    },
    {
      name: "astro",
      color: "#981dc4",
      position: [0, 0, -0.305],
      scale: [1, 0.9, 1],
      textPosition: [0, 0.02, 0],
    },
    {
      name: "threejs",
      color: "#d6ab5a",
      position: [0, 0, -0.412],
      scale: [1, 1.2, 1.1],
      textPosition: [0, 0.02, 0],
    },
    {
      name: "typescript",
      color: "#2492ed",
      position: [0, 0, -0.515],
      scale: [1, 1.25, 1],
      textPosition: [0, 0.065, 0],
    },
    {
      name: "next",
      color: "#757d94",
      position: [0, 0, -0.615],
      scale: [1, 1, 1],
      textPosition: [0, -0.01, 0],
    },
  ],
  middleRow: [
    {
      name: "nodejs",
      color: "#339e6b",
      position: [0, 0, 0.015],
      scale: [1, 1.25, 1],
      textPosition: [0, 0.02, 0],
    },
    {
      name: "express",
      color: "#baaa1c",
      position: [0, 0, -0.091],
      scale: [1, 1.1, 1],
      textPosition: [0, 0.04, 0],
    },
    {
      name: "nest",
      color: "#B32b2b",
      position: [0, 0, -0.196],
      scale: [1, 1.15, 1],
      textPosition: [0, -0.01, 0],
    },
    {
      name: "sql",
      color: "#5599e0",
      position: [0, 0, -0.294],
      scale: [1, 1.05, 1],
      textPosition: [0, -0.03, 0],
    },
    {
      name: "no sql",
      color: "#7f53cf",
      position: [0, 0, -0.392],
      scale: [1, 1, 1],
      textPosition: [0, 0.025, 0],
    },
    {
      name: "web3",
      color: "#3fab9d",
      position: [0, 0, -0.492],
      scale: [1, 0.9, 1],
      textPosition: [0, 0.005, 0],
    },
  ],
  bottomRow: [
    {
      name: "aws",
      color: "#d69147",
      position: [0, 0, 0.015],
      scale: [1, 1.1, 1],
      textPosition: [0, -0.02, 0],
    },
    {
      name: "docker",
      color: "#1C90ED",
      position: [0, 0, -0.09],
      scale: [1, 1, 1],
      textPosition: [0, 0.04, 0],
    },
    {
      name: "rpa",
      color: "#9636bf",
      position: [0, 0, -0.194],
      scale: [1, 0.9, 1],
      textPosition: [0, -0.01, 0],
    },
  ],
};
